module.exports = __webpack_public_path__ + "static/Flavor_18AMT90230-01e5def6427b1e5eb470456fc940a280.pdf";